// extracted by mini-css-extract-plugin
module.exports = {"w1n4xpv0":"w1n4xpv0","f11yt02u":"f11yt02u","l4lt3li":"l4lt3li","n1xnjemb":"n1xnjemb","f1uk3miv":"f1uk3miv"};